import { NavLink, useLocation } from 'react-router-dom';
import { findActiveNav } from './navConfig';
import './SectionTabs.css';

/**
 * Horizontal sub-tab bar for the active section's items, shown under the
 * topbar. Hidden when the current route isn't in the nav, or when the
 * active section has a single item (Overview, Projects) — a one-tab bar is
 * noise. Active tab is derived from the URL, so clicking a sidebar
 * category (which navigates to its first item) updates these tabs.
 */
export function SectionTabs(): JSX.Element | null {
  const { pathname } = useLocation();
  const active = findActiveNav(pathname);
  if (!active || active.section.items.length <= 1) return null;

  return (
    <nav className="sub-tabs" aria-label={`${active.section.label} sections`}>
      {active.section.items.map((item) => {
        const isActive = item.to === active.item.to;
        return (
          <NavLink
            key={item.to}
            to={item.to}
            className={() => `sub-tab${isActive ? ' active' : ''}`}
            aria-current={isActive ? 'page' : undefined}
          >
            {item.label}
          </NavLink>
        );
      })}
    </nav>
  );
}
